import fetchJsonp from "fetch-jsonp";
const URL_BO = import.meta.env.VITE_BO_ADMIN;

export const placeholders = (n = 4, key = "id") =>
  new Array(n).fill(0).map((_, i) => ({ [key]: i, placeholder: true }));

export const getRelatori = async () => {
  //const response = await fetch("/mock/relatori.json");
  const response = await fetch(`/api/relatori`);
  const data = response.json();
  return data;
};

export const getProtagonisti = async (letter) => {
  const response = await fetch(`/api/relatori?bio=1&startsWith=${letter}`);
  const data = response.json();
  return data;
};

export const getLuoghi = async () => {
  //const response = await fetch("/mock/luoghi.json");
  const response = await fetch("/api/locations");
  const data = response.json();
  return data;
};

export const search = async (params, scuola) => {
  //const response = await fetch("/mock/results.json");
  const response = await fetch(
    `/api/search?sezione_fe=${
      scuola ? "2" : "1"
    }&order_r=titolo&${params.toString()}`
  );
  const data = response.json();
  return data;
};

export const getEventSlugById = async (id) => {
  console.log("getEventSlugById: ", id);
  const response = await fetch(`/events/id/${id}.json`);
  if (!response.ok) {
    throw new Error(`Error ${response.status} ${response.statusText}`);
  }
  const data = await response.json();
  return data?.slug;
};

export const getEvent = async (slug) => {
  console.log("getEvent", slug);
  try {
    const response = await fetch(`/events/${slug}.json`);
    if (!response.ok) {
      throw new Error(`Error ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (e) {
    return null;
  }
};

export const getBooking = async (id, isAmico) => {
  console.log("fetch slot", id, isAmico);
  const methodName = isAmico ? "slotaf_finder.php" : "slot_finder.php";
  const bookingUrl = `${URL_BO}/fadmin/ecommerce/${methodName}?id_evento=${id}`;
  const response = await fetchJsonp(bookingUrl);
  //const bookingUrl = `/mock/slot.json`;
  //const response = await fetch(bookingUrl);
  const data = await response.json();

  if (data.error_code) {
    //gestione errore applicativo
    throw new Error(data.error_code);
  }

  return data;
};
